import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { getUserId } from "../../reducers/selectors";
import DealsRoutes from "../dealsRouting/DealsRoutes";
import DKGlobalThemeGallery from "../../helpers/DKGlobalThemeGallery";
import ClientsPage from "../../components/lawfirm/clients/ClientsPage";
import CompanyInformationPage from "../../components/company/CompanyInformationPage";
import AcceptLawFirmClientRequestPage from "../../components/company/AcceptLawFirmClientRequestPage";

const AuthenticatedRoutes = () => {
  return (
    <Switch>
      <Route exact path={`/`} component={() => <DealsRoutes />} />
      <Route path={`/:orgId/deals/`} component={() => <DealsRoutes />} />
      <Route
        exact
        path={"/law-firms/:lawFirmOrgId/clients"}
        component={ClientsPage}
      />
      <Route
        exact
        path={"/companies/:companyOrgId"}
        component={CompanyInformationPage}
      />
      <Route
        exact
        path={
          "/companies/:companyOrgId/law-firm-client/:lawFirmClientId/accept"
        }
        component={AcceptLawFirmClientRequestPage}
      />
      <Route
        exact
        path={`/styles`}
        component={() => <DKGlobalThemeGallery />}
      />
      <Redirect to={`/`} />
    </Switch>
  );
};

const mapStateToProps = (state) => {
  return {
    userId: getUserId(state),
  };
};

export default withRouter(connect(mapStateToProps)(AuthenticatedRoutes));
